import { render, staticRenderFns } from "./CompanyUsersView.vue?vue&type=template&id=52895edc&scoped=true"
import script from "./CompanyUsersView.vue?vue&type=script&lang=js"
export * from "./CompanyUsersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52895edc",
  null
  
)

export default component.exports